import {AxiosError} from 'axios';

export function parseErrorMessage(error: AxiosError): string {
    return error.response ? error.response.data.message : error.message
}
